export const translations = {
  configuracoes: {
    pt: 'Configurações',
    en: 'Settings',
    de: 'Einstellungen',
    es: 'Configuración',
  },
  novoAlerta: {
    pt: 'Novo Alerta',
    en: 'New Alert',
    de: 'Neuer Alarm',
    es: 'Nueva alerta',
  },
  cadastrar: {
    pt: 'Salvar',
    en: 'Save',
    de: 'Speichern',
    es: 'Ahorrar',
  },
  remover: {
    pt: 'Remover',
    en: 'Remove',
    de: 'Löschen',
    es: 'Retirar',
  },
  voltar: {
    pt: 'Voltar',
    en: 'Go back',
    de: 'Geh zurück',
    es: 'Regresa',
  },
  cancelar: {
    pt: 'Cancelar',
    en: 'Cancel',
    de: 'kündiger',
    es: 'Cancelar',
  },
  nome: {
    pt: 'Nome',
    en: 'Name',
    de: 'Name',
    es: 'Nombre',
  },
  linhaDenegocio: {
    pt: 'Deseja realmente remover esse segmento?',
    en: 'Do you really want to remove this segment?',
    de: 'Möchten Sie dieses Segment wirklich entfernen?',
    es: '¿Realmente deseas eliminar este segmento?',
  },
  editarLinha: {
    pt: 'Editar Segmento',
    en: 'Edit Segment',
    de: 'Segment bearbeiten',
    es: 'Editar Segmento',
  },
  setorAtividade: {
    pt: 'Setor de Atividade Divisão',
    en: 'Activity Sector Division',
    de: 'Abteilung für Tätigkeitsbereiche',
    es: 'División de Sector de Actividad',
  },
  descricao: {
    pt: 'Descrição',
    en: 'Description',
    de: 'Beschreibung',
    es: 'Descripción',
  },
  unidade: {
    pt: 'Unidade',
    en: 'Unit',
    de: 'Einheit',
    es: 'Unidad',
  },
};